import * as React from 'react';
import { AboutUs } from './../Components/aboutus';
import { connect } from 'react-redux';
import LayoutContainer from './layoutContainer';


class AboutUsContainers extends React.Component<any, any>
{
    public constructor(props) {
        super(props);
    }

    public render(): any {
        return <LayoutContainer><AboutUs {...this.props} /></LayoutContainer>
    }
}


function mapStateToProps(state) {

    var obj = state.mainReducer;
    var newObj: any = {};

    for (var key in obj) {
        if (key != null) {
            newObj[key] = obj[key];
        }
    }

    return newObj;
}

export default connect(mapStateToProps)(AboutUsContainers);



// WEBPACK FOOTER //
// ./ClientApp/app/Containers/aboutUsContainer.tsx